import React, { useCallback } from 'react'

import { NODE_TRIGGER_BUTTON_PREFIX } from 'common/builder/components/chart/FlowChart/constants'
import { FlowChartTrigger } from 'common/builder/components/chart/FlowChart/types/FlowChartTrigger'

import { TriggerDefaultContent } from './TriggerDefaultContent'
import { TriggerIcon } from './TriggerIcon'
import { TriggerView } from './TriggerView'

interface TriggerProps {
  trigger: FlowChartTrigger
  selected?: boolean
  activeStateIsVisible: boolean
  isInteractionsDisabled: boolean
  onClick(triggerId: string): void
}

export const Trigger = (props: TriggerProps) => {
  const { trigger, selected = false, activeStateIsVisible, onClick } = props

  const { id: triggerId } = trigger

  const isDisabled = !trigger.isActive || !activeStateIsVisible
  const isClickableTrigger = trigger.isInteractive && !props.isInteractionsDisabled
  const isDisabledLabelVisible = !trigger.isActive && activeStateIsVisible

  const handleClick = useCallback(() => onClick(triggerId), [onClick, triggerId])

  return (
    <TriggerView
      id={`${NODE_TRIGGER_BUTTON_PREFIX}_${triggerId}`}
      icon={<TriggerIcon trigger={trigger} />}
      content={<TriggerDefaultContent trigger={trigger} />}
      disabled={isDisabled}
      showDisabledLabel={isDisabledLabelVisible}
      selected={selected}
      isClickableTrigger={isClickableTrigger}
      onClick={handleClick}
    />
  )
}
